export const checkPermission = (module: string, action?: string): boolean => {
  try {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    // console.log('All permissions:', permissions);
    // console.log('Checking module:', module, 'action:', action);
    
    const modulePermission = permissions.find((p: any) => p.name === module);
    // console.log('Found module permission:', modulePermission);
    
    if (!modulePermission) {
      // console.log('Module permission not found');
      return false;
    }
    
    if (!action) {
      // console.log('No action specified, returning true for module existence');
      return true;
    }
    
    // console.log('Module actions:', modulePermission.actions);
    const hasAction = modulePermission.actions.some((a: any) => a.action === action && a.status === true);
    // console.log('Has action:', hasAction);
    return hasAction;
  } catch (error) {
    console.error('Error checking permission:', error);
    return false;
  }
}; 